import {
  type AuthenticationResultType,
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
} from '@aws-sdk/client-cognito-identity-provider';

type GetCognitoTokenOptions = {
  region: string;
  clientId: string;
};

export const getCognitoToken = async (username: string, password: string, options: GetCognitoTokenOptions): Promise<AuthenticationResultType> => {
  const cognitoClient = new CognitoIdentityProviderClient({
    region: options.region,
  });

  const { AuthenticationResult } = await cognitoClient.send(new InitiateAuthCommand({
    AuthFlow: 'USER_PASSWORD_AUTH',
    ClientId: options.clientId,
    AuthParameters: {
      USERNAME: username,
      PASSWORD: password,
    },
  }));

  return AuthenticationResult!;
};
